export default __webpack_public_path__ + "static/media/icon_zone_control_5.05978ce5.png";